<template lang="pug">
div
    div(
        class="tl-input-select"
        :class="{ opaq: opaq, 'animation-shake': isError, disabled: disabled }"
        @click="select()"
    )
        tl-position(
            y="center"
        )
            tl-input-checkbox(
                v-model="modelState"
                :color="disabled ? 'black' : color"
                :disabled="disabled"
                :error="error"
                :rules="rules"
                circle
                external
                style="pointer-events: none"
                @reset-error="isError = false"
                @validated="(val) => (isError = val !== true)"
            )

        div(
            :class="{ 'text-color-error': !!isError }"
            class="text-4 text-dense"
        )
            slot
</template>

<script setup>
import { computed, ref, watch, inject, onMounted } from 'vue'
import uniqid from 'uniqid'
import { promiseTimeout } from '@vueuse/core'
import { getInjects } from '@/components/$tl/utils/injects'
import { useEventBus } from '@vueuse/core'
import useRules from './validator/rules'

const props = defineProps({
    type: String,
    color: String,
    modelValue: Boolean,
    focus: Boolean,
    rules: Array,
    disabled: Boolean,
    opaq: Boolean,
    error: [String, Boolean],
})

const { validateLogic } = useRules()
const emit = defineEmits(['validated', 'update:modelValue', 'resetError'])
const injects = getInjects(props, inject)

const modelState = ref(props.modelValue)
const id = ref(null)
const input = ref(null)
const internalError = ref(null)

// const type = computed(() => props.type ?? injects.type?.value ?? 'text')
const color = computed(() => props.color ?? injects.color?.value ?? 'black')
const modelValue = computed(() => props.modelValue ?? injects.modelValue?.value)
// const focus = computed(() => props.focus ?? injects.focus?.value)
const disabled = computed(() => props.disabled ?? injects.disabled?.value)
const opaq = computed(() => props.opaq ?? injects.opaq?.value)
const rules = computed(() => props.rules ?? injects.rules?.value)
const error = computed(() => (props.error ? props.error : internalError.value))

const isError = ref(props.error)
watch(error, (val) => {
    isError.value = val
})

// const rippleColor = computed(() => {
//     let c = color.value
//     if (error.value) c = 'error'
//     if (disabled.value) return 'transparent'
//     return `var(--color-${c}-tint-light)`
// })

const select = async () => {
    await promiseTimeout(100)
    modelState.value = true
}

watch(modelValue, (val) => {
    if (val !== modelState.value) modelState.value = val
})

watch(modelState, (val) => emit('update:modelValue', val))

onMounted(() => {
    id.value = uniqid()
    useEventBus(`validate-${id.value}`).on(() => {
        validateLogic(props, modelState, input, internalError, emit)
    })

    useEventBus(`clear-error-${id.value}`).on(() => {
        emit('resetError')
    })
})
</script>

<style lang="sass" scoped>
.tl-input-select
    width: 100%
    box-shadow: none
    font-family: var(--font-family-secondary)
    font-size: 16px
    overflow: hidden
    cursor: pointer
    transition: var(--transition-default)
    display: flex
    align-items: center

    >div
        display: grid
        grid-template-columns: 20px 1fr
        grid-gap: 20px
        align-items: center
        transition: var(--transition-default)
        min-height: 30px
        transform-origin: center left
    &.disabled
        cursor: not-allowed !important
        >div
            transform: scale(0.9)
            opacity: 0.7
</style>
